import { SmartphotoNotification } from './notification/smartphoto-notification.class';
export class SmartphotoNotifications {
    notifications = [];
    constructor(notifications) {
        this.notifications = notifications.map((notification) => new SmartphotoNotification(notification));
    }
    get nextReminder() {
        return this.notifications
            .filter((notification) => notification.status === 0)
            .filter((notification) => ['reminder', 'deferred'].includes(notification.type) || notification.type.includes('days'))
            .sort((a, b) => a.scheduled - b.scheduled)
            .at(0);
    }
}
